import { render, staticRenderFns } from "./GuidedPrompt.vue?vue&type=template&id=7229ef62&scoped=true&"
import script from "./GuidedPrompt.vue?vue&type=script&lang=js&"
export * from "./GuidedPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229ef62",
  null
  
)

export default component.exports